export function PolicyModel(dict) {
    this.policyDoc_desc = [];
    if (dict.PolicyDoc_desc instanceof Array) {
        for (let i=0; i<dict.PolicyDoc_desc.length; i++) {
            this.policyDoc_desc.push(new policyDocModel(dict.PolicyDoc_desc[i]));
        }
    }
    this.effective_date = dict.effective_date;
    this.expire_date = dict.expire_date;

    this.group_sub_class = {
        ETag : dict.group_sub_class.ETag,
        groupSubClassName : dict.group_sub_class.GroupSubClassName,
        iconUrl : dict.group_sub_class.IconUrl,
        partitionKey : dict.group_sub_class.PartitionKey,
        rowKey : dict.group_sub_class.RowKey,
        timestamp :dict.group_sub_class.Timestamp
    };

    this.main_class = dict.main_class;
    this.main_class_name = dict.main_class_name;

    try {
        this.policy_desc = {
            brand: dict.policy_desc[0].detail,
            model: dict.policy_desc[1].detail,
            register: dict.policy_desc[2].detail,
        };
    } catch (e) {
        console.log(e)
    }

    this.policy_no = dict.policy_no;
    this.policy_plan = dict.policy_plan;
    this.policy_type = dict.policy_type;
    this.premium = dict.premium;
    this.renew_status = dict.renew_status;
    this.sub_class = dict.sub_class;
}
export function policyDocModel(dict) {
    this.url = dict.URL;
    this.docType = dict.docType;
    this.supDocType = dict.supDocType;
}
export function PolicyDetailModel(dict) {
    this.account_type = dict.account_type;
    this.addresses = dict.addresses;
    this.agent_card = dict.agent_card;
    this.agent_code = dict.agent_code;

    if (dict.main_class == '2') {
        try {
            this.coverage = {
                type : dict.coverage[0].detail,
                driver_name : dict.coverage[1].detail,
                insured_value : '',
                damages : '',
                protection_top_up : '',
                riders: []
            };

            // เก็บค่า coverage array ที่ label 'ผู้ขับขี่คนที่' ลงใน riders
            let remainingCoverage = [];
            if (dict.coverage && Array.isArray(dict.coverage)) {
                for (let i = 0; i < dict.coverage.length; i++) {
                    if (dict.coverage[i].label && dict.coverage[i].label.includes('ผู้ขับขี่คนที่')) {
                        this.coverage.riders.push(dict.coverage[i]);
                    } else if (i > 1) { // ข้าม type และ driver_name ที่ใช้แล้ว
                        remainingCoverage.push(dict.coverage[i]);
                    }
                }
                
                // นำ coverage array ที่เหลือมาใส่ใน insured_value, damages, protection_top_up
                if (remainingCoverage.length > 0) {
                    this.coverage.insured_value = remainingCoverage[0] ? remainingCoverage[0].detail : '';
                }
                if (remainingCoverage.length > 1) {
                    this.coverage.damages = remainingCoverage[1] ? remainingCoverage[1].detail : '';
                }
                if (remainingCoverage.length > 2) {
                    this.coverage.protection_top_up = remainingCoverage[2] ? remainingCoverage[2].detail : '';
                }
            }
        } catch (e) {
            console.log(e)
        }
    } else {
        this.coverage = dict.coverage
    }


    this.effective_date = dict.effective_date;
    this.expire_date = dict.expire_date;
    this.inform_name = dict.inform_name;
    this.main_class = dict.main_class;
    this.main_class_name = dict.main_class_name;

    if (dict.main_class == '2') {
        try {
            this.policy_desc = {
                assured: dict.policy_desc[0].detail,
                register: dict.policy_desc[1].detail,
                province: dict.policy_desc[2].detail == '' ? '-' : dict.policy_desc[2].detail,
                brand: dict.policy_desc[3].detail,
                model: dict.policy_desc[4].detail,
                color: dict.policy_desc[5].detail == '' ? '-' : dict.policy_desc[5].detail,
            };
        } catch (e) {
            console.log(e)
        }
    } else {
        this.policy_desc = dict.policy_desc
    }

    this.policy_no = dict.policy_no;
    this.policy_plan = dict.policy_plan;
    this.policy_type = dict.policy_type;
    this.premium = dict.premium;
    this.premium_net = dict.premium_net;
    this.stamp_duty = dict.stamp_duty;
    this.sub_class = dict.sub_class;
    this.vat = dict.vat;

    this.isEv = dict.isEv ? dict.isEv : false;
    if (this.isEv) {
        if (this.isEv) {
            this.drivers = dict.drivers
        }
    }
}
export function ClaimModel(dict) {
    this.acdno = dict.acdno;
    this.policy_no = dict.policy_no;
    this.claim_type_code = dict.claim_type_code;
    this.claim_type_name = dict.claim_type_name;
    this.claim_status = dict.claim_status;
    this.notify_datetime = dict.notify_datetime;
    this.occurrence_datetime = dict.occurrence_datetime;
    this.occurrence_place = dict.occurrence_place;
    this.occurrence_lat = dict.occurrence_lat;
    this.occurrence_lon = dict.occurrence_lon;
    this.surveyor_name = dict.surveyor_name;
    this.tracking_rul = dict.tracking_rul;
}
